import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ArrowLeft } from 'basic-components/icons';

import { statusesActions } from 'actions/modules/statuses';

import './Header.scss';

const Header = () => {
  const dispatch = useDispatch(),
        back = useCallback(() => dispatch(statusesActions.back()), [dispatch]),
        name = useSelector(state => state.statusesState.name)

  return (
    <div className="statuses__history__header">
      <div 
          className="statuses__history__header__back"
          onClick={back}
      >
        <ArrowLeft
            color="grey-medium"
            height={24}
            width={24}
        />
      </div>
      <div className="statuses__history__header__name">
        {name}
      </div>
    </div>
  )
}

export default memo(Header);